export default "__VITE_ASSET__wqEPUUQm__"